import React from 'react';

import { CircleIconColorType, IconType, LinkButton } from 'ui/component';
import { HomeCard } from '../home-card';
import classNames from './EABD2HomeCardFront.module.scss';

export interface HomeCardFrontProps
  extends Readonly<{
    icon: IconType;
    iconColor: CircleIconColorType;
    title: string;
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeCardFront = React.memo<HomeCardFrontProps>((props) => {
  const { icon, iconColor, title, onButtonPress, style } = props;

  const TextCallback = React.useCallback(() => {
    return <p className={classNames.text}>{title}</p>;
  }, [title]);

  const ButtonCallback = React.useCallback(() => {
    return <LinkButton text={'Show more'} arrowPosition={'after'} arrowDirection={'right'} color={'primary'} onPress={onButtonPress} />;
  }, [onButtonPress]);

  return (
    <HomeCard
      icon={icon}
      iconColor={iconColor}
      shouldUseIconOutlineStyle={false}
      textElementRenderer={TextCallback}
      buttonElementRenderer={ButtonCallback}
      style={style}
    />
  );
});
